import * as actionsTypes from "../actions/actionTypes";
import { toast } from "react-toastify";

import { authenticate } from "../../utils/auth";
import axiosInstance from "../../utils/axiosInstance";

export const authStart = () => {
  return {
    type: actionsTypes.AUTH_START,
  };
};

export const authSuccess = (message) => {
  return {
    type: actionsTypes.AUTH_SUCCESS,
    message: message,
  };
};
export const authLogout = () => {
  localStorage.removeItem("userId");
  localStorage.removeItem("imageUrl");
  localStorage.removeItem("token");
  localStorage.removeItem("userName");
  localStorage.removeItem("bio");
  localStorage.removeItem("phone");
  localStorage.removeItem("city");
  localStorage.removeItem("country");

  return {
    type: actionsTypes.AUTH_LOGOUT,
  };
};

export const authSignInSuccess = (
  token,
  userId,
  userName,
  imageUrl = null,
  bio,
  city,
  country,
  phone
) => {
  return {
    type: actionsTypes.AUTH_SIGNIN_SUCCESS,
    token: token,
    userId: userId,
    userName: userName,
    imageUrl: imageUrl,
    bio: bio,
    city: city,
    country: country,
    phone: phone,
  };
};

export const authError = (errorMsg) => {
  return {
    type: actionsTypes.AUTH_ERROR,
    errorMsg: errorMsg,
  };
};

export const activationSuccess = (message, name) => {
  return {
    type: actionsTypes.AUTH_ACTIVATION_SUCCESS,
    message: message,
    userName: name,
  };
};

export const authActivation = (token) => {
  return (dispatch) => {
    dispatch(authStart());
    axiosInstance
      .post("/activation", { token })
      .then((response) => {
        dispatch(
          activationSuccess(response.data.message, response.data.user.name)
        );
        toast.success(response.data.message);
      })
      .catch((err) => {
        dispatch(authError(err.response.data.error));
        toast.error(err.response.data.error);
      });
  };
};

export const authRegister = (name, email, password) => {
  return (dispatch) => {
    dispatch(authStart());
    axiosInstance
      .post("/register", { name, email, password })
      .then((response) => {
        dispatch(authSuccess(response.data.message));
        toast.success(response.data.message);
      })
      .catch((err) => {
        dispatch(authError(err.response.data.error));
        toast.error(err.response.data.error);
      });
  };
};

export const authSignIn = (email, password) => {
  return (dispatch) => {
    dispatch(authStart());
    axiosInstance
      .post("/login", { email, password })
      .then((response) => {
        dispatch(
          authSignInSuccess(
            response.data.token,
            response.data.user._id,
            response.data.user.name,
            response.data.user.imageUrl,
            response.data.user.bio,
            response.data.user.address.city,
            response.data.user.address.country,
            response.data.user.phone
          )
        );
        authenticate(response, () => {
          toast.success(response.data.msg);
        });
        toast.warn(response.data.error);
      })
      .catch((err) => {
        dispatch(authError(err.response.data.error));
        toast.error(err.response.data.error);
      });
  };
};

export const authPasswordForget = (email) => {
  return (dispatch) => {
    dispatch(authStart());
    axiosInstance
      .put("/password/forget", { email })
      .then((response) => {
        toast.success("L'email a bien été envoyé, consultez vos mails ");
      })
      .catch((err) => {
        dispatch(authError(err.response.data.error));
        toast.error(err.response.data.error);
      });
  };
};

export const authPasswordReset = (password1, token) => {
  return (dispatch) => {
    dispatch(authStart());
    axiosInstance
      .put("/password/reset", {
        newPassword: password1,
        resetPasswordLink: token,
      })
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        dispatch(authError(err.response.data.error));
        toast.error(err.response.data.error);
      });
  };
};

export const authCheckStatus = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const imageUrl = localStorage.getItem("imageUrl");
    const bio = localStorage.getItem("bio");
    const phone = localStorage.getItem("phone");
    const country = localStorage.getItem("country");
    const city = localStorage.getItem("city");

    if (!token) {
      dispatch(authLogout());
    } else {
      dispatch(
        authSignInSuccess(
          token,
          userId,
          userName,
          imageUrl,
          bio,
          city,
          country,
          phone
        )
      );
    }
  };
};
